import { Space, Tag, Typography } from 'antd'

interface Props {
  scopes: string[]
  disabled?: boolean
  onRemove: (scope: string) => void
}

/** Held scopes missing from the catalog; removable only on purpose. */
export function UnknownScopes({ scopes, disabled, onRemove }: Props) {
  if (!scopes.length) return null
  return (
    <div data-testid="unknown-scopes" style={{ marginTop: 16 }}>
      <Typography.Text type="secondary">Not in scope catalog</Typography.Text>
      <Space wrap style={{ display: 'flex', marginTop: 4 }}>
        {scopes.map((scope) => (
          <Tag
            key={scope}
            closable={!disabled}
            onClose={(event) => {
              event.preventDefault()
              onRemove(scope)
            }}
          >
            {scope}
          </Tag>
        ))}
      </Space>
    </div>
  )
}
